import { FC } from 'react';
import { Error, FlexContainer, LoadingIndicator } from 'components';
import TemplateList from './TemplateList';
import { useResource } from 'hooks';
import { TEMPLATES_QUERY_KEY } from 'hooks/query-keys';
import { Template } from 'types/template';

const TemplateListContainer: FC = () => {
    const { items, setCurrentPage, currentPage, pageCount, isError, error } =
        useResource<Template>({
            url: '/api/ui/templates/get',
            queryKey: TEMPLATES_QUERY_KEY,
            id: 'TEMPLATE_LIST'
        });

    if (isError) {
        return <Error error={error} />;
    }

    return (
        <FlexContainer>
            <LoadingIndicator />
            {items && (
                <TemplateList
                    templates={items}
                    currentPage={currentPage}
                    pageCount={pageCount}
                    setCurrentPage={setCurrentPage}
                />
            )}
        </FlexContainer>
    );
};

export default TemplateListContainer;
